import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../app/commonReducer';
import { Responsive } from './../responsive';
import Image from './Image';

class GridImage extends React.Component {
  getChartingUrl = code => {
    const { listOrganizationByOrganCode, locale, theme } = this.props;
    const params = new URLSearchParams();
    params.append(
      'code',
      listOrganizationByOrganCode[code] &&
        listOrganizationByOrganCode[code].ticker,
    );
    params.append('lang', locale);
    params.append('theme', theme);
    return `/charting?${params.toString()}`;
  };

  renderContentScroll = () => {
    const { listId, component, getImageFromRedux, fetchImage } = this.props;

    return (
      <div className="px-20 pb-10">
        <Responsive component={component} margin={10} offsetWidth={40}>
          {listId.map(item => {
            return () => (
              <a target="_blank" rel="noopener noreferrer">
                <Image
                  code={item}
                  fetchImage={fetchImage}
                  getImageFromRedux={getImageFromRedux}
                />
              </a>
            );
          })}
        </Responsive>
      </div>
    );
  };

  render() {
    return this.renderContentScroll();
  }
}

GridImage.propTypes = {
  listId: PropTypes.array.isRequired,
  component: PropTypes.object.isRequired,
  getImageFromRedux: PropTypes.func.isRequired,
  fetchImage: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  listOrganizationByOrganCode: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  theme: state.theme,
  locale: state.i18n.locale,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
});

export default connect(mapStateToProps)(GridImage);
